/* eslint-disable prefer-template */
import PageTitle from "../../../components/PageTitle";
import Button from "../../../components/Button";
import TabContext from "@mui/lab/TabContext";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { useNavigate } from "react-router-dom";
import Table from "../../../components/Table/Table";
import { TableSearch } from "../../../components/Table/TableActions";
import { useEffect, useState } from "react";
import { Icon } from "@iconify/react";
import Modal from "../../../components/Modal";
import useStyles from "../styles";
import { Grid, Menu, MenuItem, IconButton } from "@mui/material";
import { useUserState } from "../../../context/UserContext";
import InputGroup from "../../../components/FormComponent/InputGroup";
import SelectGroup from "../../../components/FormComponent/SelectGroup";
import { httprequest } from "../../../data/api";
import useWindowSize from "../../../hooks/useWindow";
import { toast } from "react-toastify";
import useValidator from "../../../hooks/useValidator";
import Select from "react-select";
import PopModal from "../../../components/PopupModal/PopModal";
import CSVExport from "../../../components/CsvExport/CsvExport";

const SUBJECTS_ENDPOINT = "/api/v1/subjects";
const TEACHERS_ENDPOINT = "/api/v1/teachers";
const CLASSES_ENDPOINT = "/api/v1/class";
const CLASS_SUBJECT_ENDPOINT = "/api/v1/class-subject";

const ActionMenu = ({ row, handleEdit, handleDelete, viewLink, syllabusLink }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const navigate = useNavigate();
  const open = Boolean(anchorEl);
  const handleClick = (e) => setAnchorEl(e.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const handleView = () => {
    handleClose();
    navigate(viewLink);
  };

  const handleEditClick = () => {
    handleClose();
    handleEdit(row);
  };

  const handleDeleteClick = () => {
    handleClose();
    handleDelete(row);
  };

  const handleSyllabusClick = () => {
    handleClose();
    navigate(syllabusLink);
  };

  return (
    <div key={row?.id} className="table-action-container">
      <IconButton onClick={handleClick} size="small" className="table-action-icon">
        <Icon icon="fluent:more-vertical-16-regular" />
      </IconButton>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        <MenuItem onClick={handleView}>
          <Icon icon="fluent:eye-16-regular" style={{ marginRight: 8 }} /> View Details
        </MenuItem>
        <MenuItem onClick={handleEditClick}>
          <Icon icon="heroicons:pencil-square-solid" style={{ marginRight: 8 }} /> Edit
        </MenuItem>
        <MenuItem onClick={handleDeleteClick} sx={{ color: "error.main" }}>
          <Icon icon="mingcute:delete-2-line" style={{ marginRight: 8 }} /> Delete
        </MenuItem>
        <MenuItem onClick={handleSyllabusClick}>
          <Icon icon="ph:book-open-text-light" style={{ marginRight: 8 }} /> View Syllabus
        </MenuItem>
      </Menu>
    </div>
  );
};

const EmployerSubject = () => {
  const classes = useStyles();
  const { profile, userRole } = useUserState();
  const syllabusBasePath = userRole?.role_type === "employee"
    ? "/class-activities/employee/syllabus"
    : "/class-activities/employer/syllabus";
  const [currentRow, setCurrentRow] = useState({});
  const [classSubjectRow, setClassSubjectRow] = useState({});
  const [isDeleting, setIsDeleting] = useState(false);
  const [value, setValue] = useState("1");
  const [deleteModal, setDeleteModal] = useState(false);
  const [subjectArr, setSubjectArr] = useState([""]);
  const [isCreating, setIsCreating] = useState(false);
  const [isAssigning, setIsAssigning] = useState(false);
  const [editIsAssigning, setEditIsAssigning] = useState(false);
  const [subjectsData, setSubjectsData] = useState([]);
  const [teacherData, setTeacherData] = useState([]);
  const [classesData, setClassData] = useState([]);
  const [isClassLoading, setIsClassLoading] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [subjectByClass, setSubjectByClass] = useState([]);
  const [classSubjectModal, setClassSubjectModal] = useState(false);
  const [selectedTeachers, setSelectedTeachers] = useState([]);
  const [subjectForm, setSubjectForm] = useState({
    name: subjectArr
  });
  const [editSubject, setEditSubject] = useState({
    name: ""
  });

  const width = useWindowSize();
  const mobile = width < 600;
  const [selectedRows, setSelectedRows] = useState([]);

  // --| handle change for tab
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const [subjectValidator, showSubjectValidator] = useValidator();
  const [assignValidator, showAssignValidator] = useValidator();
  const [editAssignValidator, showEditAssignValidator] = useValidator();
  const [searchResult, setSearchResult] = useState([]);
  const [subjectResultByClass, setSearchResultByClass] = useState([]);
  const [editSubjectModal, setEditSubjectModal] = useState(false);
  const [assignsubjectmodal, setAssignSubjectModal] = useState(false);
  const [editassignModal, setEditAssignModal] = useState(false);
  const [addsubjectModal, setSubjectModal] = useState(false);
  // const [teacherArr, setTeacherArr] = useState([""]);
  const [assignForm, setAssignForm] = useState({
    subject_id: "",
    class_id: "",
    teacher_id: []
  });

  const [editAssignForm, setEditAssignForm] = useState({
    // subject_id: "",
    // class_id: "",
    teacher_id: []
  });

  /**
 * Handle opening the edit assign form modal.
 * Populates selected teacher data and current form values.
 *
 * @param {Object} row - Selected row data containing subject and teacher info.
 */
  const handleEditAssignFormModal = (row) => {
    setCurrentRow(row);
    const formattedSelectedTeachers = row?.teachers.map((teacher) => ({
      teacher_id: teacher.teacher_id,
      teacher_name: `${teacher.first_name} ${teacher.last_name}`
    }));
    setSelectedTeachers(formattedSelectedTeachers);
    setEditAssignForm({
      ...editAssignForm,
      class_subject_id: row?.class_subject_id,
      subject_id: row?.subject_id,
      teacher_id: row?.teachers.map((id) => id?.teacher_id)
    });
    setEditAssignModal(true);
  };

  /**
 * Close the Edit Assign Form modal and reset form state.
 */
  const handleCloseEditAssignFormModal = () => {
    setCurrentRow({});
    setEditAssignForm({
      ...editAssignForm,
      subject_id: "",
      // class_id: "",
      teacher_id: ""
    });
    setEditAssignModal(false);
  };

  /**
 * Handle change in Edit Subject form fields.
 *
 * @param {Object} e - Event object from input.
 */
  const handleEditSubject = (e) => {
    const { name, value } = e.target;
    setEditSubject({ ...editSubject, [name]: value });
  };

  /**
 * Open Edit Subject modal and populate form with current data.
 *
 * @param {Object} row - Subject data row to be edited.
 */
  const handleEditSubjectModal = (row) => {
    setCurrentRow(row);
    setEditSubject({
      ...editSubject,
      name: row?.name
    });
    setEditSubjectModal(!editSubjectModal);
  };

  /**
 * Close Edit Subject modal and reset the form state.
 */
  const handleCloseEditSubjectModal = () => {
    setCurrentRow({});
    setEditSubjectModal(!editSubjectModal);
    setEditSubject({
      ...editSubject,
      name: ""
    });
  };

  /**
 * Close Assign Teacher modal and reset the form state.
 */
  const handleCloseAssignTecherModal = () => {
    setAssignSubjectModal(false);
    // setTeacherArr([""]);
    setSubjectForm({ subject_id: "", class_id: "", teacher_id: [""] });
  };

  /**
 * Handle input change for assigning subject.
 *
 * @param {Object} e - Event object from input.
 */
  const handleAssignChange = (e) => {
    const { name, value } = e.target;
    setAssignForm({ ...assignForm, [name]: value });
  };

  /**
 * Handle subject input change for multiple subjects.
 *
 * @param {Object} e - Event object from input.
 * @param {number} index - Index of the subject input.
 */
  const handleSubjectChange = (e, index) => {
    const { value } = e.target;
    const allSubjects = [...subjectArr];
    allSubjects[index] = value;
    setSubjectArr(allSubjects);
    setSubjectForm({ ...subjectForm, name: allSubjects });
  };

  /**
 * Handle multiple teacher selection for assigning.
 *
 * @param {Array} selectedOptions - Selected teacher options.
 */
  const handleMultipleAccessChange = (selectedOptions) => {
    const selectedValues = selectedOptions.map((option) => option?.teacher_id);
    setAssignForm({ ...assignForm, teacher_id: selectedValues });
  };

  /**
 * Handle multiple teacher selection for editing assign form.
 *
 * @param {Array} e - Selected teacher options.
 */
  const handleEditMultipleAccessChange = (e) => {
    const selectedValues = e.map((option) => (option?.teacher_id));
    setEditAssignForm({ ...editAssignForm, teacher_id: selectedValues });
  };

  /**
 * Add an additional empty subject input to the form.
 */
  const AddAdditionalSubject = () => {
    const newSubject = "";
    setSubjectArr([...subjectArr, newSubject]);
    setSubjectForm({ ...subjectForm, name: [...subjectArr, newSubject] });
  };

  /**
 * Delete a subject entry from the form based on index.
 *
 * @param {number} index - Index of the subject to delete.
 */
  const handleDeleteSubjectItem = (index) => {
    const newSubject = subjectArr.filter((_item, ind) => ind !== index);
    setSubjectArr(newSubject);
    setSubjectForm({ ...subjectForm, name: newSubject });
  };

  /**
 * Toggle Assign Subject modal visibility.
 */
  const handleAssignSubjectModal = () => {
    setAssignSubjectModal(!assignsubjectmodal);
  };

  /**
 * Toggle Add Subject modal visibility.
 */
  const handleAddSubjectModal = () => {
    setSubjectModal(!addsubjectModal);
  };

  /**
 * Close Add Subject modal and reset form state.
 */
  const handleCloseAddSubjectModal = () => {
    setSubjectModal(!addsubjectModal);
    setSubjectArr([""]);
    setSubjectForm({ name: [""] });
  };

  /**
 * Open Delete modal for a selected subject row.
 *
 * @param {Object} row - Selected subject row.
 */
  const handleDeleteModal = (row) => {
    setCurrentRow(row);
    setDeleteModal(!deleteModal);
  };

  /**
 * Open Delete Class Subject modal.
 *
 * @param {Object} row - Row data of class subject to delete.
 */
  const handleDeleteClassSubjectModal = (row) => {
    setClassSubjectRow(row);
    setClassSubjectModal(!classSubjectModal);
  };

  /**
 * Close the Delete modal.
 */
  const handleCloseDeleteModal = () => {
    setDeleteModal(false);
  };

  /**
 * Close the Delete Class Subject modal.
 */
  const handleCloseDeleteClassSubjectModal = () => {
    setClassSubjectModal(false);
  };

  /**
 * Fetch all available subjects from API.
 */
  const getAllSubjects = () => {
    httprequest
      .get(SUBJECTS_ENDPOINT)
      .then((res) => {
        setSubjectsData(res?.data?.data);
        setSearchResult(res?.data?.data);
      })
      .catch((err) => {
        toast.error(err?.response?.data);
      });
  };

  /**
 * Fetch subjects assigned to a specific class based on `value`.
 */
  const getSubjectsClass = () => {
    httprequest
      .get(`${CLASS_SUBJECT_ENDPOINT}/${value}`)
      .then((res) => {
        setSubjectByClass(res?.data?.data);
        setSearchResultByClass(res?.data?.data);
      })
      .catch((err) => {
        toast.error(err?.response?.data);
      });
  };

  useEffect(() => {
    if (value !== "1") {
      getSubjectsClass();
    }
  }, [value]);

  /**
 * Fetch all available teachers from API.
 * Format the data for use in dropdowns.
 */
  const getAllTeachers = () => {
    httprequest
      .get(TEACHERS_ENDPOINT)
      .then((res) => {
        const formattedData = res?.data?.data.map((teacher) => ({
          teacher_id: teacher?.employee_id,
          teacher_name: `${teacher.first_name} ${teacher.last_name}`
        }));
        setTeacherData(formattedData);
      })
      .catch((err) => {
        toast.error(err?.response?.data);
      });
  };

  /**
 * Fetches all classes from the API and filters only those of type "physical".
 * Updates the state with the filtered class data.
 * @function getAllClasses
 */
  const getAllClasses = () => {
    setIsClassLoading(true);
    httprequest
      .get(CLASSES_ENDPOINT)
      .then((res) => {
        const physicalClasses = res?.data?.data?.filter(
          (data) => data?.class_type === "physical"
        );
        setClassData(physicalClasses);
        setIsClassLoading(false);
      })
      .catch((err) => {
        setIsClassLoading(false);
        toast.error(err?.response?.data);
      });
  };

  /**
 * Handles the creation of a new subject. Validates the form before submission.
 * On success, it refreshes the subjects list and closes the modal.
 * @function handleCreateSubjects
 */
  const handleCreateSubjects = () => {
    if (subjectValidator.allValid()) {
      setIsCreating(true);
      httprequest
        .post(SUBJECTS_ENDPOINT, subjectForm)
        .then((res) => {
          setIsCreating(false);
          toast.success(res?.data?.message);
          getAllSubjects();
          handleCloseAddSubjectModal();
        })
        .catch((err) => {
          setIsCreating(false);
          toast.error(err?.response?.data?.message);
        });
    } else {
      showSubjectValidator(true);
    }
  };

  /**
 * Edits an existing subject using its ID.
 * Sends a PATCH request with updated data and handles UI feedback and state.
 * @function handleEditASubject
 */
  const handleEditASubject = () => {
    setIsEditing(true);
    httprequest.patch(`${SUBJECTS_ENDPOINT}/${currentRow?.id}`, editSubject).then((res) => {
      setIsEditing(false);
      toast.success(res?.data?.message);
      getAllSubjects();
      handleCloseEditSubjectModal();
    }).catch((err) => {
      setIsEditing(false);
      toast.error(err?.response?.data?.message);
    });
  };

  /**
 * Deletes a subject using its ID and updates the subject list after deletion.
 * @function handleDeleteSubject
 */
  const handleDeleteSubject = () => {
    setIsDeleting(true);
    httprequest.delete(`${SUBJECTS_ENDPOINT}/${currentRow?.id}`).then((res) => {
      setIsDeleting(false);
      toast.success(res?.data?.message);
      handleCloseDeleteModal();
      getAllSubjects();
    }).catch((err) => {
      setIsDeleting(false);
      toast.error(err?.response?.data?.message);
    });
  };

  /**
 * Deletes a class-subject assignment by subject ID.
 * Refreshes subject and class-subject data after deletion.
 * @function handleDeleteClassSubject
 */
  const handleDeleteClassSubject = () => {
    setIsDeleting(true);
    httprequest.delete(`${SUBJECTS_ENDPOINT}/${classSubjectRow?.subject_id}`).then((res) => {
      setIsDeleting(false);
      toast.success(res?.data?.message);
      handleCloseDeleteClassSubjectModal();
      getAllSubjects();
      getSubjectsClass();
    }).catch((err) => {
      setIsDeleting(false);
      toast.error(err?.response?.data?.message);
    });
  };

  /**
 * Assigns a teacher to a subject for a specific class.
 * Validates the assign form and sends the assignment request to the backend.
 * @function handleAssignSubject
 */
  const handleAssignSubject = () => {
    if (assignValidator.allValid()) {
      setIsAssigning(true);
      const { subject_id, teacher_id, class_id } = assignForm;
      httprequest
        .post(
          `${CLASS_SUBJECT_ENDPOINT}/assign-subject`,
          { subject_id, teacher_id, class_id }
        )
        .then((res) => {
          setIsAssigning(false);
          toast.success(res?.data?.message);
          getAllSubjects();
          getAllClasses();
          handleCloseAssignTecherModal();
        })
        .catch((err) => {
          setIsAssigning(false);
          toast.error(err?.response?.data?.message);
        });
    } else {
      showAssignValidator(true);
    }
  };

  /**
 * Edits the teacher assigned to an already assigned class-subject.
 * Validates the form and sends a teacher update request.
 * Forces page reload after assignment to refresh class-subject mapping.
 * @function handleEditAssignSubjectToTeacher
 */
  const handleEditAssignSubjectToTeacher = () => {
    if (editAssignValidator.allValid()) {
      setEditIsAssigning(true);
      const { teacher_id } = editAssignForm;
      httprequest
        .post(
          `${CLASS_SUBJECT_ENDPOINT}/assign-teacher`,
          { teacher_id, class_subject_id: editAssignForm?.class_subject_id }
        )
        .then((res) => {
          setEditIsAssigning(false);
          toast.success(res?.data?.message);
          getAllSubjects();
          getAllClasses();
          handleCloseEditAssignFormModal();
        })
        .catch((err) => {
          setEditIsAssigning(false);
          toast.error(err?.response?.data?.message);
        });
    } else {
      showEditAssignValidator(true);
    }
  };

  /**
 * useEffect hook to run once on component mount.
 * Fetches all subjects, teachers, and classes initially.
 * @function useEffect
 */
  useEffect(() => {
    getAllSubjects();
    getAllTeachers();
    getAllClasses();
  }, []);

  /**
 * Columns configuration for the subject table.
 * Includes subject name, creation and update dates, and action buttons.
 * @const {Array} columns
 */
  const columns = [
    {
      name: "Subject",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Subject</p>}
          {row?.name}
        </>
      )
    },
    {
      name: "Date Created",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Date Created</p>}
          {row?.created_at?.substring(0, 10)}
        </>
      )
    },
    {
      name: "Date Updated",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Date Updated</p>}
          {row?.updated_at?.substring(0, 10)}
        </>
      )
    },
    {
      name: "",
      center: "true",
      sortable: false,
      cell: (row) => (
        <ActionMenu
          row={row}
          handleEdit={handleEditSubjectModal}
          handleDelete={handleDeleteModal}
          viewLink={`/subjects/all-subject-result/${row?.id}`}
          syllabusLink={`${syllabusBasePath}/${row?.id}`}
        />
      )
    }
  ];

  /**
 * Columns configuration for the class-subject table.
 * Includes subject name, assigned teacher, and timestamps.
 * @const {Array} subjectColumns
 */
  const subjectColumns = [
    {
      name: "Subject",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Subject</p>}
          {row?.subject_name}
        </>
      )
    },
    {
      name: "Assigned Teacher",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Assigned Teacher</p>}
          {row?.teachers?.map(
            (teacher) => `${teacher?.first_name} ${teacher?.last_name}`
          ).join(", ")}
        </>
      )
    },
    {
      name: "Date Created",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Date Created</p>}
          {row?.created_at?.substring(0, 10)}
        </>
      )
    },
    {
      name: "Date Updated",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Date Updated</p>}
          {row?.updated_at?.substring(0, 10)}
        </>
      )
    },
    {
      name: "",
      center: true,
      sortable: false,
      cell: (row) => (
        <ActionMenu
          row={row}
          handleEdit={handleEditAssignFormModal}
          handleDelete={handleDeleteClassSubjectModal}
          viewLink={`/subjects/subject-result/${row?.subject_id}?class_id=${value}`}
          syllabusLink={`${syllabusBasePath}/${row?.subject_id}?class_id=${value}`}
        />
      )
    }
  ];
  /**
 * Filters the main subject table based on input keywords.
 * Checks for partial matches on subject name, status, label, or type.
 * @function handleSearchSubject
 * @param {Event} e - Input change event from search field.
 */
  const handleSearchSubject = (e) => {
    const { value } = e.target;

    const valArray = value.split(" ");
    // --| Filter data by partial match onchange in the search input box
    const result = subjectsData?.filter((data) => valArray?.every((word) => data?.name?.toLowerCase().includes(word.toLowerCase()) ||
          data?.status
            ?.toLowerCase().includes(word.toLowerCase()) ||
          data?.label?.toLowerCase().includes(word.toLowerCase()) ||
          data?.type?.toLowerCase().includes(word.toLowerCase())
    )
    );
    setSearchResult(result);
  };

  /**
 * Filters the class-subject table based on input keywords.
 * Checks for partial matches on teacher name, subject name, label, or type.
 * @function handleSearchSubjectByClass
 * @param {Event} e - Input change event from search field.
 */
  const handleSearchSubjectByClass = (e) => {
    const { value } = e.target;

    const valArray = value.split(" ");
    // --| Filter data by partial match onchange in the search input box
    const result = subjectByClass?.filter((data) => valArray?.every((word) => data?.teacher_name
      ?.toLowerCase().includes(word.toLowerCase()) ||
          data?.subject_name?.toLowerCase().includes(word.toLowerCase()) ||
          data?.label?.toLowerCase().includes(word.toLowerCase()) ||
          data?.type?.toLowerCase().includes(word.toLowerCase())
    )
    );
    setSearchResultByClass(result);
  };

  // const { subject_id, teacher_id } = editAssignForm;

  return (
    <>
      <PageTitle
        title="All Subjects"
        subtitle="See all the subjects currently in your school, can and remove at your convenience."
        button={
          <div className="flex gap-10">
            <PopModal videoUrl="https://youtu.be/74VA38oeyi0" title="Subject" modalKey="subject" />
            <Button
              onClick={handleAssignSubjectModal}
              variant="primaryoutline"
              buttonSize="fluid"
              color="btnfontprimary"
              buttonName="Assign Subject"
            />
            <Button
              onClick={handleAddSubjectModal}
              variant="primary"
              buttonSize="fluid"
              color="btndefault"
              buttonName="Create Subject"
            />
          </div>
        }
      />
      <div className="page-content">
        <TabContext value={value}>
          <div className="tablist-container padding-left-16">
            <Tabs
              className="overide-tablist"
              onChange={handleChange}
              aria-label="lab API tabs example"
            >
              <Tab label="All" value="1" data={profile} />
              {isClassLoading ? (
                <div className="container-left">
                  <Icon icon="eos-icons:three-dots-loading" width="50" height="50" />
                </div>
              ) : (
                classesData?.map((data) => {
                  return (
                    <Tab
                      key={data?.id}
                      value={data?.id}
                      label={data?.class_name}
                    />
                  );
                })
              )}
            </Tabs>
          </div>
          <TabPanel sx={{ padding: "0px !important" }} value="1" className="tabpanel-overide">
            <Table
              data={searchResult}
              columns={columns}
              subHeader={true}
              pagination
              handleRowSelected={({ selectedRows }) => setSelectedRows(selectedRows.map(row => row.id))}
              subHeaderComponent={
                subjectsData?.length > 0 && (
                  <div className="action_div">
                    <TableSearch
                      placeholder="Search here..."
                      searchTableFunc={handleSearchSubject}
                    />
                    <CSVExport
                      data={searchResult}
                      filename="Subject_export"
                      idKey="id"
                      selectedRows={selectedRows}
                      fields={[
                        { path: "name", header: "Subject Name" },
                        { path: "created_at", header: "Date Created" }
                      ]}
                    />
                  </div>
                )}
            />
          </TabPanel>
          {classesData?.map((data) => {
            return (
              <TabPanel sx={{ padding: "0px !important" }} key={data?.id} value={data?.id}>
                <Table
                  data={subjectResultByClass}
                  columns={subjectColumns}
                  subHeader={true}
                  pagination
                  subHeaderComponent={
                    subjectsData?.length > 0 && (
                      <TableSearch
                        placeholder="Search here..."
                        searchTableFunc={handleSearchSubjectByClass}
                      />
                    ) }
                />
              </TabPanel>
            );
          })}
        </TabContext>
      </div>
      {/* Assign Subject Modal */}
      <Modal
        title="Assign Subject"
        subtitle={
          <div>Assign a Subject Teacher to a subject in the selected class.</div>
        }
        modalContent={
          <>
            <Grid container spacing={2} className="input-padding">
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <div className="multiple-select">
                  <p>Subject Teacher</p>
                  <Select isMulti name="teacher_id"
                    closeMenuOnSelect={true} options={teacherData} onChange={handleMultipleAccessChange}
                    getOptionLabel={(option) => option.teacher_name}
                    getOptionValue={(option) => option.teacher_id}
                  />
                </div>
                {/* {assignValidator.message("Access", teacher_id, "required")} */}
              </Grid>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <SelectGroup
                  label="Subject"
                  required
                  children={
                    <select name="subject_id" onChange={handleAssignChange}>
                      <option value="">--- Select ---</option>
                      {subjectsData?.map((subject) => {
                        return (
                          <option key={subject.id} value={subject?.id}>
                            {subject?.name}
                          </option>
                        );
                      })}
                    </select>
                  }
                />
                {assignValidator.message(
                  "subject_id",
                  assignForm?.subject_id,
                  "required"
                )}
              </Grid>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <SelectGroup
                  label="Class"
                  required
                  children={
                    <select name="class_id" onChange={handleAssignChange}>
                      <option value="">--- Select ---</option>
                      {classesData?.map((item) => {
                        return (
                          <option key={item.id} value={item.id}>
                            {item?.class_name}
                          </option>
                        );
                      })}
                    </select>
                  }
                />
                {assignValidator.message(
                  "class_id",
                  assignForm?.class_id,
                  "required"
                )}
              </Grid>
            </Grid>
          </>
        }
        modalFooter={
          <>
            <div className={classes.modalFooterBtn}>
              <Button
                variant="primary"
                buttonSize="full"
                color="btndefault"
                buttonName="Assign Subject"
                isLoading={isAssigning}
                onClick={handleAssignSubject}
              />
            </div>
          </>
        }
        isopen={assignsubjectmodal}
        closeModal={handleAssignSubjectModal}
      />
      {/* Edit Assign Subject Modal */}
      <Modal
        title="Edit Assign Subject"
        subtitle={
          <div>Edit an Assigned Subject Teacher to a subject in the selected class.</div>
        }
        modalContent={
          <>
            <Grid container spacing={2} className="input-padding">
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <div className="multiple-select">
                  <p>SubjectTeacher</p>
                  <Select
                    isMulti
                    name="teacher_id"
                    closeMenuOnSelect={true}
                    options={teacherData}
                    onChange={handleEditMultipleAccessChange}
                    defaultValue={selectedTeachers}
                    getOptionLabel={(option) => option?.teacher_name}
                    getOptionValue={(option) => option?.teacher_id}
                  />

                </div>
                {/* {editAssignValidator.message("teacher_id", teacher_id, "required")} */}
              </Grid>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                {editAssignForm?.subject_id && (
                  <SelectGroup
                    label="Subject"
                    required
                    children={
                      <select disabled value={editAssignForm?.subject_id} name="subject_id">
                        <option value="">--- Select ---</option>
                        {subjectsData?.map((subject) => {
                          return (
                            <option key={subject.id} value={subject?.id}>
                              {subject?.name}
                            </option>
                          );
                        })}
                      </select>
                    }
                  />
                )}
                {/* {editAssignValidator.message("subject_id", subject_id, "required")} */}
              </Grid>
              {/* <Grid item lg={12} md={12} sm={12} xs={12}>
                <SelectGroup
                  label="Class"
                  required
                  children={
                    <select disabled defaultValue={editAssignForm?.class_id} name="class_id" onChange={handleEditAssignSubject}>
                      <option value="">--- Select ---</option>
                      {classesData?.map((item) => {
                        return (
                          <option key={item.id} value={item.id}>
                            {item?.class_name}
                          </option>
                        );
                      })}
                    </select>
                  }
                />
                {assignValidator.message(
                  "class_id",
                  assignForm?.class_id,
                  "required"
                )}
              </Grid> */}
            </Grid>
          </>
        }
        modalFooter={
          <>
            <div className={classes.modalFooterBtn}>
              <Button
                variant="primary"
                buttonSize="full"
                color="btndefault"
                buttonName="Edit Assign Subject"
                isLoading={editIsAssigning}
                onClick={handleEditAssignSubjectToTeacher}
              />
            </div>
          </>
        }
        isopen={editassignModal}
        closeModal={handleCloseEditAssignFormModal}
      />
      {/* Create Subject Modal */}
      <Modal
        title="Create Subject"
        subtitle={
          <div>
            Create a new subject and assign a teacher to teach the subject.
          </div>
        }
        modalContent={
          <>
            <Grid container spacing={2} className="input-padding">
              <Grid item lg={12} md={12} sm={12} xs={12}>
                {subjectArr?.map((item, index) => (
                  <div key={index}>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <InputGroup
                        label="Subject Name"
                        margin="normal"
                        required
                        placeHolder="Enter subject name"
                        inputType="text"
                        onChange={(e) => handleSubjectChange(e, index)}
                        value={item}
                      />
                    </Grid>
                    <Grid item lg={6} md={6} sm={6} xs={12}>
                      {subjectForm?.name?.length > 1 ? (
                        <p
                          className="delete-input"
                          onClick={() => {
                            handleDeleteSubjectItem(index);
                          }}
                        >
                          <Icon icon="zondicons:minus-solid" />
                          Remove this subject
                        </p>
                      ) : null}
                    </Grid>
                  </div>
                ))}
              </Grid>
              <div
                className={`${classes.mail} flex align-items-center`}
                onClick={AddAdditionalSubject}
              >
                <Icon icon="octicon:feed-plus-16" width="16" height="16" />
                <p>Add another subject</p>
              </div>
            </Grid>
          </>
        }
        modalFooter={
          <>
            <div className={classes.modalFooterBtn}>
              <Button
                variant="primary"
                buttonSize="full"
                color="btndefault"
                buttonName="Add Subject(s)"
                onClick={handleCreateSubjects}
                isLoading={isCreating}
              />
            </div>
          </>
        }
        isopen={addsubjectModal}
        closeModal={handleCloseAddSubjectModal}
      />
      {/* Edit Subject Modal */}
      <Modal
        title="Edit Subject"
        subtitle={
          <div>
            Edit subject{currentRow?.name}.
          </div>
        }
        modalContent={
          <>
            <Grid container spacing={2} className="input-padding">
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <InputGroup
                  label="Subject Name"
                  margin="normal"
                  required
                  placeHolder="Enter subject name"
                  inputType="text"
                  inputName="name"
                  onChange={handleEditSubject}
                  defaultValue={editSubject?.name}
                />
              </Grid>
            </Grid>
          </>
        }
        modalFooter={
          <>
            <div className={classes.modalFooterBtn}>
              <Button
                variant="primary"
                buttonSize="full"
                color="btndefault"
                buttonName="Edit Subject"
                onClick={handleEditASubject}
                isLoading={isEditing}
              />
            </div>
          </>
        }
        isopen={editSubjectModal}
        closeModal={handleCloseEditSubjectModal}
      />
      {/* Delete Modal */}
      <Modal
        title="Delete Subject"
        subtitle={
          <div>
            Are you sure you want to delete{" "}
            <span className="modal-name-highlight">{currentRow?.name}</span>.
            Deleting is a permanent action`
          </div>
        }
        modalContent={<></>}
        modalFooter={
          <>
            <Button
              variant="danger"
              buttonName="Delete Subject"
              buttonSize="full"
              color="btndefault"
              isLoading={isDeleting}
              onClick={handleDeleteSubject}
            />
          </>
        }
        isopen={deleteModal}
        closeModal={handleCloseDeleteModal}
      />
      {/* Delete Class Subject Modal */}
      <Modal
        title="Delete Subject"
        subtitle={
          <div>
            Are you sure you want to delete{" "}
            <span className="modal-name-highlight">{classSubjectRow?.subject_name}</span>.
            Deleting is a permanent action`
          </div>
        }
        modalContent={<></>}
        modalFooter={
          <>
            <Button
              variant="danger"
              buttonName="Delete Class Subject"
              buttonSize="full"
              color="btndefault"
              isLoading={isDeleting}
              onClick={handleDeleteClassSubject}
            />
          </>
        }
        isopen={classSubjectModal}
        closeModal={handleCloseDeleteClassSubjectModal}
      />
      {/* <ToastContainer /> */}
    </>
  );
};

export default EmployerSubject;
